import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=1b3947dd&scoped=true&"
import script from "./CategoryButton.vue?vue&type=script&lang=ts&"
export * from "./CategoryButton.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=1b3947dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3947dd",
  null
  
)

export default component.exports